import React, { useEffect, useMemo, useState } from 'react';
import { Button, Card, Flex, Form, Typography, Select, Modal, Upload, Tabs, Space, Input, DatePicker, Divider, Col, Row, Empty } from 'antd';
import PageHeader from '../../view/pageheader';
import { DownloadOutlined, PlusOutlined, SaveOutlined, UploadOutlined, PrinterOutlined, ReloadOutlined, ScanOutlined, SearchOutlined } from '@ant-design/icons';
import { updateWeareHouseData, weareHouseById, updateWareHousestatus, completedweareHouseById, uploadWeareHouseData, clearWareHouseyIdData, clearCompletedWareHouseByIdData } from "../../store/reducer/wearehouseSlice";
import { getJobsList } from "../../store/reducer/jobSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { toast } from 'react-toastify'
import { FileAllType } from '../../store/reducer/prepQueueSlice';
import TableComponent from '../CustomComponents/TableComponent';
import { getCustomerList } from "../../store/reducer/customerSlice";
import moment from "moment-timezone";
import Loader from '../../fields/Loader/Loader';
import SearchComponent from '../CustomComponents/SearchComponent';
import dayjs from 'dayjs';
import TextArea from 'antd/es/input/TextArea';
const { TabPane } = Tabs;
const { Title, Text } = Typography;
const WareHouse = () => {
    const params = useParams();
    const id = params.all;
    const location = useLocation();
    const params1 = new URLSearchParams(location.search);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const getQueryParams = () => {
        const params = new URLSearchParams(location.search);
        return {
            query: params.get("query") || "",
        };
    };
    const [preprocessingQueueData, setPreprocessingQueueData] = useState([]);
    const [completedPreprocessingQueueData, setCompletedPreprocessingQueueData] = useState([]);
    const [completedOrginalData, setCompletedOrginalData] = useState([]);
    const [customerList, setCustomerList] = useState([]);
    const [jobData, setJobData] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const { weareHouseByIdData, weareHouseLoading, completedWeareHouseByIdData } = useSelector((state) => state.wearehouse);
    const { customerListData } = useSelector((state) => state.customers);
    const { AllFileData } = useSelector((state) => state.prepTeamQueue);
    const { jobListData } = useSelector((state) => state.jobs);
    const userId = localStorage.getItem('user_id');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [uploadModalVisible, setUploadModalVisible] = useState(false);
    const [modifiedRows, setModifiedRows] = useState(new Set());
    const [fileData, setFileData] = useState([])
    const [activetab, setActiveTab] = useState("1")
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [barocdestartvalue, setBarocdestartvalue] = useState('');
    const [barocdeendvalue, setBarocdeendvalue] = useState('');
    const [uniqueIdStartValue, setUniqueIdStartValue] = useState('');
    const [uniqueIdEndValue, setUniqueIdEndValue] = useState('');
    const [pendingPayload, setPendingPayload] = useState(null);
    const [searchModal, setSearchModal] = useState(false)
    const [clearData, setClearData] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [isProcessModalOpen, setIsProcessModalOpen] = useState(false);

    function getAllData(payload = {}) {
        dispatch(getJobsList(payload))
        dispatch(FileAllType(payload))
        dispatch(getCustomerList(payload))

    }
    function getData(payload = {}) {
        const query = payload.query || '';
        if (id) {
            getAllData()
            const editId = window.atob(id);
            const assign_user_id = localStorage.getItem('user_id');
            //   dispatch(clearCompletedBox());
            //   dispatch(clearnotCompletedBox());
            if (activetab == '1') {

                dispatch(weareHouseById({ editId, query, ...payload, }));

            }
            else if (activetab == '2') {
                dispatch(completedweareHouseById({ editId, query, assign_user_id, payload }));
            }

        }

    }
    useEffect(() => {
        if (id && activetab && pendingPayload !== null) {
            getData(pendingPayload);
        }
    }, [id, activetab, pendingPayload]);
    useEffect(() => {
        const { query } = getQueryParams();

        const payload = {};
        if (query && query.trim() !== "") {
            setSearchText(query.trim());
            payload.query = query.trim();
        }

        // if (pickup_date) {
        //     setSearchDate(pickup_date); // keep as string if backend expects MM/DD/YYYY
        //     payload.pickup_date = pickup_date;
        // }

        if (payload.query) {
            setPendingPayload(payload);
            setActiveTab("2");
        } else {
            setPendingPayload({});
            // setActiveTab(id === "all" ? "2" : "1");
        }
    }, [id, location.search]);
    useEffect(() => {
        let formattedData1 = [];
        if (activetab == '1' && Array.isArray(weareHouseByIdData?.data)) {

            formattedData1 = weareHouseByIdData?.data.map((item, index) => ({
                ...item,
                key: index.toString(),
            }));
        }

        if (formattedData1.length > 0) {
            setPreprocessingQueueData(formattedData1);
            setOriginalData(JSON.stringify(formattedData1));
        }
    }, [weareHouseByIdData, activetab]);

    useEffect(() => {
        let formattedData2 = [];
        if (activetab == '2' && Array.isArray(completedWeareHouseByIdData?.data)) {
            formattedData2 = completedWeareHouseByIdData?.data.map((item, index) => ({
                ...item,
                key: index.toString(),
            }));
        }
        if (formattedData2.length > 0) {
            setCompletedPreprocessingQueueData(formattedData2);
            setCompletedOrginalData(JSON.stringify(formattedData2));
        }
    }, [completedWeareHouseByIdData, activetab]);
    const specIdData = useMemo(() => {
        if (!preprocessingQueueData.length || !jobData.length) return [];
        return jobData
            .map((item) => ({
                label: item?.spec_id,
                value: item?.id,
                workflow_id: item?.workflow_id,
                customer_id: item?.customer_id,
                customer_name: item?.customer?.customername
            }));
    }, [jobData, preprocessingQueueData]);

    const customerLists = useMemo(() => {
        if (!customerList.length) return [];
        return customerList
            .filter((customer) => customer.status == 1)
            .map((item) => ({
                label: item.customername,
                value: item.id,
            }));
    }, [customerList]);
    const fileDatas = useMemo(() => {

        return fileData
            .map((item) => ({
                label: item?.file_type,
                value: item?.id,

            }));
    }, [fileData]);
    const handleSearch = () => {
        const payloadData = {
            query: searchText,
        };



        getData(payloadData);

        setSearchText('');

    };
    const handleTabChange = (key) => {
        navigate(`?tab=${key}`);
        window.location.reload(); //
    };

    // 
    useEffect(() => {
        const urlTab = params1.get("tab");
        if (urlTab) {
            setActiveTab(urlTab);
        }
    }, [location.search]);
    const handleDownloadExcel = () => {

        const tableData = preprocessingQueueData.map(
            ({
                box_unique_id, spec, box, alt_box, barcode, from, to, printed_name, date_in, description, series_box, loc, building, aisle, level, shelf, customer_name,
            }) => ({
                'Unique ID': box_unique_id,

                'From': from,
                'To': to,
                'Label Printed Name/Date': printed_name,
                'Date In (mm/dd/yyyy)': date_in ? moment(date_in).format("MM/DD/YYYY") : null,
                'Description': description,
                'Series Box': series_box,
                'Loc': loc,
                'Building or Address': building,
                'Aisle': aisle,
                'Level': level,
                'Shelf': shelf,

            })
        );

        // Create headers
        const combinedSheetData = [['Allowed Spec Id', 'All File Types']];

        // Get max length to iterate safely
        const maxLength = Math.max(specIdData.length, fileDatas.length, customerLists.length);

        const customerMap = {};
        customerList.forEach(customer => {
            customerMap[customer.id] = customer.customername;
        });
        const ws1 = XLSX.utils.json_to_sheet(tableData);
        const ws2 = XLSX.utils.aoa_to_sheet(combinedSheetData);
        const colWidth1 = 25;
        ws1['!cols'] = Object.keys(tableData[0] || {}).map(() => ({ wch: colWidth1 }));
        const colWidth2 = 30;
        ws2['!cols'] = combinedSheetData[0].map(() => ({ wch: colWidth2 }));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws1, 'Preprocessing Queue');
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(data, 'WareHouse.xlsx');
    };
    const handleDownloadBarcodeExcel = () => {
        const invalidRows = selectedRowKeys.filter(
            (item) =>
                item.spec &&
                (item.description == null || item.from == null || item.to == null)
        );
        if (invalidRows.length > 0) {
            toast.error("Description, From, and To are required when Spec ID is selected!");
            return;
        }
        if (selectedRowKeys.length == 0) {
            toast.error("Please select at least one row to download the barcode Excel file.");
            return;
        }
        const tableData = selectedRowKeys.map(
            ({
                box_unique_id, spec, box, alt_box, barcode, from, to, printed_name, date_in, description, series_box, loc, building, aisle, level, shelf, left_warehouse,
            }) => ({

                'Spec ID': spec,
                'Box': box,
                'Alt Box': alt_box,
                'Scantek Barcode': barcode,
                'From': from,
                'To': to,
                'Description': description,


                // 'Left Warehouse (mm/dd/yyyy)': left_warehouse ? moment(left_warehouse).format("MM/DD/YYYY") : null,



                // 'Address': address,
                // 'Aisle': aisle,
                // 'Level': level,
                // 'Bay': bay,
                // 'From': from,
                // Important: Use JS Date objects so Excel recognizes them as dates
                // 'Pickup Date (mm/dd/yyyy)': pickup_date ? moment(pickup_date).format("MM/DD/YYYY") : null,
                // 'Left Warehouse (mm/dd/yyyy)': left_warehouse ? moment(left_warehouse).format("MM/DD/YYYY") : null,
            })
        );

        // Create headers
        const combinedSheetData = [['Allowed Spec Id', 'All File Types']];

        // Get max length to iterate safely
        const maxLength = Math.max(specIdData.length, fileDatas.length, customerLists.length);

        const customerMap = {};
        customerList.forEach(customer => {
            customerMap[customer.id] = customer.customername;
        });

        // Generate the combined data
        for (let i = 0; i < maxLength; i++) {
            const specId = specIdData[i]?.label ?? '';
            const customerId = specIdData[i]?.customer_name ?? '';
            const fileType = fileDatas[i]?.label ?? '';

            const customerName = customerMap[customerId] || '';
            const specWithCustomer = specId ? `${specId} - ${customerId}` : '';

            combinedSheetData.push([specWithCustomer, fileType || '']);
        }

        const ws1 = XLSX.utils.json_to_sheet(tableData);
        const ws2 = XLSX.utils.aoa_to_sheet(combinedSheetData);
        const colWidth1 = 25;
        ws1['!cols'] = Object.keys(tableData[0] || {}).map(() => ({ wch: colWidth1 }));
        const colWidth2 = 30;
        ws2['!cols'] = combinedSheetData[0].map(() => ({ wch: colWidth2 }));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws1, 'Preprocessing Queue');
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(data, 'scatek_barcode.xlsx');


        const postData = {
            updatedData: selectedRowKeys.map((data) => ({
                box_unique_id: data.box_unique_id,
                spec_id: data.job_id,
                barcode: data.barcode,
                is_printed: 1,
            })),
        };
        dispatch(updateWareHousestatus({ postData }))
            .then(() => {
                // On successful save, re-fetch the updated data
                const editId = atob(id);
                const assign_user_id = localStorage.getItem('user_id');
                window.location.reload();
                dispatch(weareHouseById({ editId, assign_user_id }))
                    .then(() => {
                        toast.success("Ware House Data Updated Successfully");
                        setModifiedRows(new Set());
                    });
            })
            .catch((error) => {
                toast.error("Please Select Spec ID ")
            });

    };
    const handleDownloadUniqueIDLabel = () => {


        if (selectedRowKeys.length == 0) {
            toast.error("Please select at least one row to download the barcode Excel file.");
            return;
        }
        const tableData = selectedRowKeys.map(
            ({
                box_unique_id
            }) => ({

                'Unique ID': box_unique_id,
            })
        );

        // Create headers
        const combinedSheetData = [['Allowed Spec Id', 'All File Types']];

        // Get max length to iterate safely
        const maxLength = Math.max(specIdData.length, fileDatas.length, customerLists.length);

        const customerMap = {};
        customerList.forEach(customer => {
            customerMap[customer.id] = customer.customername;
        });

        // Generate the combined data
        for (let i = 0; i < maxLength; i++) {
            const specId = specIdData[i]?.label ?? '';
            const customerId = specIdData[i]?.customer_name ?? '';
            const fileType = fileDatas[i]?.label ?? '';

            const customerName = customerMap[customerId] || '';
            const specWithCustomer = specId ? `${specId} - ${customerId}` : '';

            combinedSheetData.push([specWithCustomer, fileType || '']);
        }

        const ws1 = XLSX.utils.json_to_sheet(tableData);
        const ws2 = XLSX.utils.aoa_to_sheet(combinedSheetData);
        const colWidth1 = 25;
        ws1['!cols'] = Object.keys(tableData[0] || {}).map(() => ({ wch: colWidth1 }));
        const colWidth2 = 30;
        ws2['!cols'] = combinedSheetData[0].map(() => ({ wch: colWidth2 }));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws1, 'Unique ID Labels');
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(data, 'export_unique_id_label.xlsx');

    };
    const excelDateToJSDate = (serial) => {
        const utc_days = Math.floor(serial - 25569);
        const utc_value = utc_days * 86400; // seconds in a day
        const date_info = new Date(utc_value * 1000); // convert to ms
        return moment(date_info).format("MM/DD/YYYY");
    };


    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setFileList([]);
    };

    const handleUpload = async () => {


        const allowedExtensions = ["xlsx", "xls", "xlsm", "xltx", "ods", "xlsb"];
        if (!fileList.length) {
            toast.error("Please select an Excel file to upload!");
            return;
        }

        const file = fileList[0];
        const fileName = file.name;


        const fileExtension = file.name.split(".").pop().toLowerCase();
        if (!allowedExtensions.includes(fileExtension)) {
            toast.error("Invalid file type! Please upload a valid Excel file.");
            return;
        }
        const reader = new FileReader();

        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });

            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(sheet)

            // const allowedSpecIds = specIdData.map((item) => item.label);
            let hasErrors = false;
            // const allSpecIdsEmpty = jsonData.every(row => row["Spec ID"] === null || row["Spec ID"] === undefined);
            // if (allSpecIdsEmpty) {
            //   toast.error("All spec IDs is Empty");
            //   hasErrors = true;
            // }
            if (jsonData.length > preprocessingQueueData.length) {
                toast.error("You have uploaded more records than allowed!");
                hasErrors = true;
            }

            jsonData.forEach((row, index) => {
                if (!row["Unique ID"]) {
                    toast.error(`Row ${index + 1}: Missing required fields.`);
                    hasErrors = true;
                }
                if (row["Date In (mm/dd/yyyy)"] && typeof row["Date In (mm/dd/yyyy)"] == "number") {
                    row["Date In (mm/dd/yyyy)"] = excelDateToJSDate(row["Date In (mm/dd/yyyy)"]);
                }


            });

            jsonData.includes(jsonData)

            if (!hasErrors) {
                const specWorkflowMap = specIdData.reduce((map, item) => {
                    map[item.label] = item.workflow_id;
                    return map;
                }, {});

                // Add workflow_id to each row in jsonData
                const processedData = jsonData.map(row => ({
                    ...row,
                    workflow_id: row["Spec ID"] ? specWorkflowMap[row["Spec ID"]] : null
                }));
                const postData = {
                    jsonData: processedData,
                    assign_user_id: userId,
                    prep_queue_id: atob(id),
                    updated_user_id: Number(localStorage.getItem('user_id')),
                    activetab: '2',
                    file_name: fileName
                }
                dispatch(uploadWeareHouseData({ postData }))
                setFileList([]);
                setUploadModalVisible(true);
                setIsModalOpen(false)
                // toast.success("Excel file uploaded successfully!");
                // navigate(`/upload-log`);

            }
        };

        reader.readAsArrayBuffer(file);
    };
    useEffect(() => {
        if (id) {
            try {
                const editId = window.atob(id)
                const assign_user_id = localStorage.getItem("user_id");

                if (assign_user_id) {
                    //   dispatch(prepQueueById({ editId, assign_user_id }));
                    // toast.success("Excel Prep Process Success");
                    setIsModalOpen(false);
                } else {
                    console.error("User ID not found in localStorage");
                }
            } catch (error) {
                console.error("Invalid base64 ID:", error);
            }
        }

        // if (addExcelPrepProcessError) {
        //   toast.error(addExcelPrepProcessErrorMessage || "An error occurred.");
        //   dispatch(resetSuccessFlag({ flag: "addExcelPrepProcessError" }));
        // }
    }, [dispatch, id, setIsModalOpen]);
    // const disabledData=preprocessingQueueData.filter((data)=>data.allocated==1)



    const columns = [
        {
            title: 'Unique ID',
            key: 'box_unique_id',
            width: '30%',
            fixed: 'left',
            render: (_, record) => {
                return record.is_moved == 1 ? (
                    <span style={{ color: 'red' }}>
                        {record.box_unique_id} — This moved to {record.moved_spec}
                    </span>
                ) : (
                    <span style={{ color: 'blue', cursor: 'pointer' }} onClick={() => {
                        setSelectedRecord(record); // set current row
                        setIsProcessModalOpen(true); // open modal
                    }}>{record.box_unique_id}</span>
                );
            },
        },

        {
            title: 'SPEC',
            dataIndex: 'spec',
            render: (text, record) => (record?.spec ? record?.spec : 'Yet to Assign'),
            key: 'spec',
            width: '30%',
            fixed: 'left',
        },
        {
            title: 'BOX',
            dataIndex: 'box',
            render: (text, record) => (record?.box >= 1 ? record?.box : '-'),
            key: 'box',
            width: '20%',
        },
        {
            title: 'ALT BOX',
            dataIndex: 'alt_box',
            render: (text, record) => (record?.alt_box >= 0 ? record?.alt_box : '-'),
            key: 'alt_box',
            width: '20%',
        },
        {
            title: 'Scantek Barcode',
            dataIndex: 'barcode',
            render: (text, record) => (record?.barcode ? record?.barcode : '-'),
            key: 'barcode',
            width: '40%',
        },
        {
            title: (<span> From <span style={{ color: 'red' }}>*</span>
            </span>
            ),
            dataIndex: 'from',
            key: 'from',
            width: '40%',
            render: (text, record) => {
                // Enable editing for both tabs 1 and 2
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input
                            disabled={record.is_moved == 1}
                            style={{ width: '200px' }}
                            value={record.from}
                            placeholder="Enter From"
                            onChange={(e) => {
                                const value = e.target.value;
                                let newData;
                                if (activetab === '1') {
                                    newData = [...preprocessingQueueData];
                                } else {
                                    newData = [...completedPreprocessingQueueData];
                                }

                                const index = newData.findIndex((item) => item.key === record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, from: value };

                                    if (activetab === '1') {
                                        setPreprocessingQueueData(newData);
                                    } else {
                                        setCompletedPreprocessingQueueData(newData);
                                    }

                                    setModifiedRows((prev) => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.from}</span>;
                }
            }
        },

        {
            title: (<span>TO <span style={{ color: 'red' }}>*</span>
            </span>
            ),
            dataIndex: 'to',
            key: 'to',
            width: '40%',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input
                            disabled={record.is_moved == 1}
                            style={{ width: '200px' }}
                            value={record.to}
                            placeholder="Enter To"
                            onChange={(e) => {
                                const value = e.target.value;
                                let newData;

                                if (activetab === '1') {
                                    newData = [...preprocessingQueueData];
                                } else {
                                    newData = [...completedPreprocessingQueueData];
                                }

                                const index = newData.findIndex((item) => item.key === record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, to: value };

                                    if (activetab === '1') {
                                        setPreprocessingQueueData(newData);
                                    } else {
                                        setCompletedPreprocessingQueueData(newData);
                                    }

                                    setModifiedRows((prev) => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.to}</span>;
                }
            },
        },
        {
            title: 'LABEL PRINTED NAME/DATE',
            dataIndex: 'printed_name',
            key: 'printed_name',
            width: '80%',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input
                            disabled={record.is_moved == 1}
                            style={{ width: '300px' }}
                            value={record.printed_name}
                            placeholder="Enter Printed Name"
                            onChange={(e) => {
                                const value = e.target.value;
                                let newData;

                                if (activetab === '1') {
                                    newData = [...preprocessingQueueData];
                                } else {
                                    newData = [...completedPreprocessingQueueData];
                                }

                                const index = newData.findIndex((item) => item.key === record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, printed_name: value };

                                    if (activetab === '1') {
                                        setPreprocessingQueueData(newData);
                                    } else {
                                        setCompletedPreprocessingQueueData(newData);
                                    }

                                    setModifiedRows((prev) => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.printed_name}</span>;
                }
            },
        },
        {
            title: (<span> Box Pickup Date <span style={{ color: 'red' }}></span>
            </span>
            ),
            dataIndex: 'date_in',
            key: 'date_in',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <DatePicker
                            disabled={record.is_moved == 1}
                            format={"MM/DD/YYYY"}
                            style={{ width: '200px' }}
                            value={record.date_in ? dayjs(record.date_in) : null}
                            placeholder="Select Date In"
                            onChange={(date, dateString) => {
                                let newData;

                                if (activetab === '1') {
                                    newData = [...preprocessingQueueData];
                                } else {
                                    newData = [...completedPreprocessingQueueData];
                                }

                                const index = newData.findIndex((item) => item.key === record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, date_in: dateString };

                                    if (activetab === '1') {
                                        setPreprocessingQueueData(newData);
                                    } else {
                                        setCompletedPreprocessingQueueData(newData);
                                    }

                                    setModifiedRows((prev) => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.date_in ? moment(record.date_in).format("MM/DD/YYYY") : '-'}</span>;
                }
            },
            width: '40%',
        },
        {
            title: (<span> DESCRIPTION <span style={{ color: 'red' }}>*</span>
            </span>
            ),
            dataIndex: 'description',
            key: 'description',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <TextArea
                            disabled={record.is_moved == 1}
                            style={{ width: '300px' }}
                            value={record.description}
                            placeholder='Enter Description'
                            onChange={(e) => {
                                const value = e.target.value;
                                let newData;

                                if (activetab === '1') {
                                    newData = [...preprocessingQueueData];
                                } else {
                                    newData = [...completedPreprocessingQueueData];
                                }

                                const index = newData.findIndex((item) => item.key == record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, description: value };

                                    if (activetab === '1') {
                                        setPreprocessingQueueData(newData);
                                    } else {
                                        setCompletedPreprocessingQueueData(newData);
                                    }

                                    setModifiedRows(prev => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.description}</span>;
                }
            },
            width: '40%',
        },
        {
            title: 'Series Box',
            dataIndex: 'series_box',
            key: 'series_box',
            width: '40%',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input
                            disabled={record.is_moved == 1}
                            style={{ width: '300px' }}
                            value={record.series_box}
                            placeholder='Enter Series Box'
                            onChange={(e) => {
                                const value = e.target.value;
                                let newData;

                                if (activetab === '1') {
                                    newData = [...preprocessingQueueData];
                                } else {
                                    newData = [...completedPreprocessingQueueData];
                                }

                                const index = newData.findIndex((item) => item.key == record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, series_box: value };

                                    if (activetab === '1') {
                                        setPreprocessingQueueData(newData);
                                    } else {
                                        setCompletedPreprocessingQueueData(newData);
                                    }

                                    setModifiedRows(prev => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.series_box}</span>;
                }
            },
        },
        {
            title: 'LOC',
            dataIndex: 'loc',
            key: 'loc',
            width: '60%',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input
                            disabled={record.is_moved == 1}
                            style={{ width: '300px' }}
                            value={record.loc}
                            placeholder='Enter Loc'
                            onChange={(e) => {
                                const value = e.target.value;
                                let newData;

                                if (activetab === '1') {
                                    newData = [...preprocessingQueueData];
                                } else {
                                    newData = [...completedPreprocessingQueueData];
                                }

                                const index = newData.findIndex((item) => item.key == record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, loc: value };

                                    if (activetab === '1') {
                                        setPreprocessingQueueData(newData);
                                    } else {
                                        setCompletedPreprocessingQueueData(newData);
                                    }

                                    setModifiedRows(prev => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.loc}</span>;
                }
            },
        },
        {
            title: 'Building or Address',
            dataIndex: 'building',
            key: 'building',
            width: '60%',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input
                            disabled={record.is_moved == 1}
                            style={{ width: '300px' }}
                            value={record.building}
                            placeholder='Enter Building'
                            onChange={(e) => {
                                const value = e.target.value;
                                let newData;

                                if (activetab === '1') {
                                    newData = [...preprocessingQueueData];
                                } else {
                                    newData = [...completedPreprocessingQueueData];
                                }

                                const index = newData.findIndex((item) => item.key == record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, building: value };

                                    if (activetab === '1') {
                                        setPreprocessingQueueData(newData);
                                    } else {
                                        setCompletedPreprocessingQueueData(newData);
                                    }

                                    setModifiedRows(prev => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.building}</span>;
                }
            }
        },
        {
            title: 'Aisle',
            dataIndex: 'aisle',
            key: 'aisle',
            width: '60%',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input
                            disabled={record.is_moved == 1}
                            style={{ width: '300px' }}
                            value={record.aisle}
                            placeholder='Enter Aisle'
                            onChange={(e) => {
                                const value = e.target.value;
                                let newData;

                                if (activetab === '1') {
                                    newData = [...preprocessingQueueData];
                                } else {
                                    newData = [...completedPreprocessingQueueData];
                                }

                                const index = newData.findIndex((item) => item.key == record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, aisle: value };

                                    if (activetab === '1') {
                                        setPreprocessingQueueData(newData);
                                    } else {
                                        setCompletedPreprocessingQueueData(newData);
                                    }

                                    setModifiedRows(prev => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.aisle}</span>;
                }
            },
        },
        {
            title: 'Level',
            dataIndex: 'level',
            key: 'level',
            width: '60%',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input
                            disabled={record.is_moved == 1}
                            style={{ width: '300px' }}
                            value={record.level}
                            placeholder='Enter Level'
                            onChange={(e) => {
                                const value = e.target.value;
                                let newData;

                                if (activetab === '1') {
                                    newData = [...preprocessingQueueData];
                                } else {
                                    newData = [...completedPreprocessingQueueData];
                                }

                                const index = newData.findIndex((item) => item.key == record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, level: value };

                                    if (activetab === '1') {
                                        setPreprocessingQueueData(newData);
                                    } else {
                                        setCompletedPreprocessingQueueData(newData);
                                    }

                                    setModifiedRows(prev => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.level}</span>;
                }
            },
        },
        {
            title: 'Shelf',
            dataIndex: 'shelf',
            key: 'shelf',
            width: '60%',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input
                            disabled={record.is_moved == 1}
                            style={{ width: '300px' }}
                            value={record.shelf}
                            placeholder='Enter Shelf'
                            onChange={(e) => {
                                const value = e.target.value;
                                let newData;

                                if (activetab === '1') {
                                    newData = [...preprocessingQueueData];
                                } else {
                                    newData = [...completedPreprocessingQueueData];
                                }

                                const index = newData.findIndex((item) => item.key == record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, shelf: value };

                                    if (activetab === '1') {
                                        setPreprocessingQueueData(newData);
                                    } else {
                                        setCompletedPreprocessingQueueData(newData);
                                    }

                                    setModifiedRows(prev => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.shelf}</span>;
                }
            },
        },
        // {
        //     title: 'Left Warehouse',
        //     dataIndex: 'left_warehouse',
        //     key: 'left_warehouse',
        //     width: '60%',
        //     render: (text, record) => (
        //         <Input style={{ width: '300px' }}
        //             value={record.left_warehouse}
        //             placeholder='Enter Building'
        //             // disabled={record.from}
        //             onChange={(e) => {
        //                 const value = e.target.value;
        //                 const newData = [...preprocessingQueueData];
        //                 const index = newData.findIndex((item) => item.key == record.key);
        //                 if (index > -1) {
        //                     newData[index] = { ...record, left_warehouse: value };
        //                     setPreprocessingQueueData(newData);
        //                     setModifiedRows(prev => new Set(prev.add(record.key)));
        //                 }
        //             }}
        //         />
        //     ),
        // }

        // {
        //   title: 'Building or Address',
        //   dataIndex: 'address',
        //   key: 'address',
        //   // width: '35%',
        //   render: (text, record) => (
        //     <Input style={{ width: '200px' }}
        //       value={record.address}
        //       placeholder='Enter Address'
        //       // disabled={record.customer_box_id}
        //       onChange={(e) => {
        //         const value = e.target.value;
        //         const newData = [...preprocessingQueueData];
        //         const index = newData.findIndex((item) => item.key == record.key);
        //         if (index > -1) {
        //           newData[index] = { ...record, address: value };
        //           setPreprocessingQueueData(newData);
        //           setModifiedRows(prev => new Set(prev.add(record.key)));
        //         }
        //       }}
        //     />
        //   ),
        // },
        // {
        //   title: 'Aisle',
        //   dataIndex: 'aisle',
        //   key: 'aisle',
        //   // width: '35%',
        //   render: (text, record) => (
        //     <Input style={{ width: '200px' }}
        //       value={record.aisle}
        //       placeholder='Enter Aisle'
        //       onChange={(e) => {
        //         const value = e.target.value;
        //         const newData = [...preprocessingQueueData];
        //         const index = newData.findIndex((item) => item.key == record.key);
        //         if (index > -1) {
        //           newData[index] = { ...record, aisle: value };
        //           setPreprocessingQueueData(newData);
        //           setModifiedRows(prev => new Set(prev.add(record.key)));
        //         }
        //       }}
        //     />
        //   ),
        // },
        // {
        //   title: 'Level',
        //   dataIndex: 'level',
        //   key: 'level',
        //   // width: '35%',
        //   render: (text, record) => (
        //     <Input style={{ width: '200px' }}
        //       value={record.level}
        //       placeholder='Enter Level'
        //       onChange={(e) => {
        //         const value = e.target.value;
        //         const newData = [...preprocessingQueueData];
        //         const index = newData.findIndex((item) => item.key == record.key);
        //         if (index > -1) {
        //           newData[index] = { ...record, level: value };
        //           setPreprocessingQueueData(newData);
        //           setModifiedRows(prev => new Set(prev.add(record.key)));
        //         }
        //       }}
        //     />
        //   ),
        // },
        // {
        //   title: 'Bay',
        //   dataIndex: 'bay',
        //   key: 'bay',
        //   // width: '35%',
        //   render: (text, record) => (
        //     <Input style={{ width: '200px' }}
        //       value={record.bay}
        //       placeholder='Enter Bay'
        //       onChange={(e) => {
        //         const value = e.target.value;
        //         const newData = [...preprocessingQueueData];
        //         const index = newData.findIndex((item) => item.key == record.key);
        //         if (index > -1) {
        //           newData[index] = { ...record, bay: value };
        //           setPreprocessingQueueData(newData);
        //           setModifiedRows(prev => new Set(prev.add(record.key)));
        //         }
        //       }}
        //     />
        //   ),
        // },
        // {
        //   title: 'From',
        //   dataIndex: 'from',
        //   key: 'from',
        //   // width: '35%',
        //   render: (text, record) => (
        //     <Input style={{ width: '200px' }}
        //       value={record.from}
        //       placeholder='Enter From'
        //       onChange={(e) => {
        //         const value = e.target.value;
        //         const newData = [...preprocessingQueueData];
        //         const index = newData.findIndex((item) => item.key == record.key);
        //         if (index > -1) {
        //           newData[index] = { ...record, from: value };
        //           setPreprocessingQueueData(newData);
        //           setModifiedRows(prev => new Set(prev.add(record.key)));
        //         }
        //       }}
        //     />
        //   ),
        // },
        // {
        //   title: 'Pickup Date',
        //   dataIndex: 'pickup_date',
        //   key: 'pickup_date',
        //   render: (text, record) => (
        //     <DatePicker
        //       format="MM/DD/YYYY"
        //       style={{ width: '200px' }}
        //       value={record.pickup_date ? dayjs(record.pickup_date) : null} // ensure moment object
        //       placeholder="Enter Pickup Date"
        //       onChange={(date) => {
        //         const newData = [...preprocessingQueueData];
        //         const index = newData.findIndex((item) => item.key === record.key);
        //         if (index > -1) {
        //           newData[index] = {
        //             ...record,
        //             pickup_date: date,
        //           };
        //           setPreprocessingQueueData(newData);
        //           setModifiedRows((prev) => new Set(prev.add(record.key)));
        //         }
        //       }}
        //     />
        //   ),
        // },
        // {
        //   title: 'Left Warehouse',
        //   dataIndex: 'left_warehouse',
        //   key: 'left_warehouse',
        //   render: (text, record) => (
        //     <DatePicker
        //       format="MM/DD/YYYY"
        //       style={{ width: '300px' }}
        //       value={record.left_warehouse ? dayjs(record.left_warehouse) : null} // ensure moment object
        //       placeholder="Enter Pickup Date"
        //       onChange={(date) => {
        //         const newData = [...preprocessingQueueData];
        //         const index = newData.findIndex((item) => item.key === record.key);
        //         if (index > -1) {
        //           newData[index] = {
        //             ...record,
        //             left_warehouse: date,
        //           };
        //           setPreprocessingQueueData(newData);
        //           setModifiedRows((prev) => new Set(prev.add(record.key)));
        //         }
        //       }}
        //     />
        //   ),
        // },
        // {
        //   title: 'Original Disposition',
        //   dataIndex: 'original_disposition',
        //   key: 'original_disposition',
        //   // width: '40%',
        //   render: (text, record) => (
        //     <Select
        //       style={{ width: '100%' }}
        //       options={original_dispositionData}
        //       value={record.original_disposition} // this should be the value
        //       placeholder="Select Original Disposition"
        //       onChange={(value,label) => {
        //         const selectedFile = original_dispositionData.find(item => item.value == value);
        //         if (!selectedFile) return;

        //         const updatedData = [...preprocessingQueueData];
        //         const index = updatedData.findIndex(item => item.key === record.key);

        //         if (index !== -1) {
        //           updatedData[index] = {
        //             ...updatedData[index],
        //             original_disposition: selectedFile.label, // store value only
        //           };
        //           setPreprocessingQueueData(updatedData);
        //           setModifiedRows(prev => new Set(prev).add(record.key));
        //         }
        //       }}
        //     />
        //   ),
        // },
        // {
        //   title: 'Disposition Days',
        //   dataIndex: 'disposition_day',
        //   key: 'disposition_day',
        //   // width: '35%',
        //   render: (text, record) => (
        //     <InputNumber style={{ width: '200px' }}
        //       value={record.disposition_day}
        //       placeholder='Enter Disposition Days'
        //       onChange={(value) => {
        //         const newData = [...preprocessingQueueData];
        //         const index = newData.findIndex((item) => item.key === record.key);
        //         if (index > -1) {
        //           newData[index] = { ...record, disposition_day: value };
        //           setPreprocessingQueueData(newData);
        //           setModifiedRows(prev => new Set(prev.add(record.key)));
        //         }
        //       }}
        //     />
        //   ),
        // },


    ];
    const getAllBarocde = preprocessingQueueData.filter((data) => data.barcode != null).map((item) => ({
        value: item.barcode,
        label: item.barcode,
    }))
    const getAllUniqueID = preprocessingQueueData.filter((data) => data.barcode != null).map((item) => ({
        value: item.box_unique_id,
        label: item.box_unique_id,
    }))
    const onSelectChange = (newSelectedRowKeys, newRow) => {
        setSelectedRowKeys(newRow);
    };
    const rowSelection = {
        onChange: onSelectChange,

        getCheckboxProps: record => ({
            disabled: record.is_moved == 1, // Example: disable row based on data
        }),
    };
    const handleSaveData = (values, actionType) => {
        const isPagination = actionType === "pagination";
        console.log(values, "isPagination==");

        let currentData, originalDataRef;

        // Determine which data to use based on active tab
        if (activetab === '1') {
            currentData = preprocessingQueueData;
            originalDataRef = originalData;
        } else if (activetab === '2') {
            currentData = completedPreprocessingQueueData;
            originalDataRef = completedOrginalData;
        } else {
            toast.error("Invalid tab selection!");
            return;
        }


        const parsedOriginalData = JSON.parse(originalDataRef);
        const updatedData = currentData.filter((item) => {
            const originalItem = parsedOriginalData.find((orig) => orig.key === item.key);
            return originalItem && JSON.stringify(originalItem) !== JSON.stringify(item);
        });
        console.log(isPagination, "isProcessModalOpen==");

        if (updatedData.length === 0 && !isProcessModalOpen) {
            if (!isPagination) toast.info("No changes detected.");
            return;
        }

        const modifiedData = updatedData.filter((item) => modifiedRows.has(item.key));
        const invalidRows = modifiedData.filter(
            (item) =>
                item.spec &&
                (item.description == null || item.description == "" || item.from == null || item.from == "" || item.to == null || item.to == "")
        );
        if (invalidRows.length > 0) {
            toast.error("Description, From,  To  are required when Spec ID is selected!");
            return;
        }
        if (modifiedData.length === 0 && !isProcessModalOpen) {
            toast.info("No modified rows to save.");
            return;
        }
        const formattedModalData = isProcessModalOpen
            ? [
                {
                    ...selectedRecord,
                    ...values,


                },
            ]
            : [];

        const postData = {
            updatedData: isProcessModalOpen ? formattedModalData : modifiedData,
            customer_id: currentData[0]?.customer_id,
            assign_user_id: userId,
            prep_queue_id: atob(id),
            activetab: '2',
            updated_user_id: Number(localStorage.getItem('user_id')),

        };
        dispatch(updateWeareHouseData({ postData }))
            .unwrap()
            .then(() => {
                window.location.reload();
                // On successful save, re-fetch the updated data for the current tab
                const editId = atob(id);
                const assign_user_id = localStorage.getItem('user_id');

                if (activetab === '1') {

                    dispatch(weareHouseById({ editId, assign_user_id }))
                        .then(() => {
                            toast.success("Data saved successfully!");
                            setModifiedRows(new Set());
                        });
                } else if (activetab === '2') {
                    dispatch(completedweareHouseById({ editId, assign_user_id }))
                        .then(() => {
                            toast.success("Data saved successfully!");
                            setModifiedRows(new Set());
                        });
                }
            })
            .catch((error) => {
                console.error("Save error:", error);
                toast.error(error.message || "Error saving data. Please check if Spec ID is selected.");
            });
    };
    const handleFilterChange = (payload = {}) => {
        const editId = window.atob(id);
        dispatch(weareHouseById({ editId, uniqueIdStartValue, uniqueIdEndValue, barocdestartvalue, barocdeendvalue, ...payload }));
        setSearchModal(false);
        setBarocdestartvalue(null);
        setBarocdeendvalue(null);
        setUniqueIdStartValue(null);
        setUniqueIdEndValue(null);


    };
    const clearFilterData = () => {
        setClearData(false);
        setBarocdestartvalue(null);
        setBarocdeendvalue(null);
        setUniqueIdStartValue(null);
        setUniqueIdEndValue(null);

    }
    return (
        <>
            <Loader loading={weareHouseLoading} />
            {/* <Loader loading={prepTeamQueueLoading} /> */}
            <PageHeader
                HeaderText="Export Barcode Labels "
                Breadcrumb={[{ name: "Export Barcode Labels" }]}
            // backButtonUrl="/wearhouse"
            />
            <Tabs activeKey={activetab} defaultActiveKey="1" onChange={handleTabChange} type="card"
                tabBarExtraContent={
                    <Flex align="center" style={{ gap: "10px", flexWrap: "wrap" }}>
                        <Button
                            style={{ backgroundColor: '#1e90a9' }}
                            shape="round"
                            type="primary"
                            icon={<PrinterOutlined />}
                            onClick={handleDownloadUniqueIDLabel}
                        >
                            Export Unique ID Label
                        </Button>

                        <Button
                            style={{ backgroundColor: '#1e90a9' }}
                            shape="round"
                            type="primary"
                            icon={<ScanOutlined />}
                            onClick={handleDownloadBarcodeExcel}
                        >
                            Export Scantek Barcode
                        </Button>


                        <Button
                            style={{ backgroundColor: "green", color: "white" }}
                            shape="round"
                            type="default"
                            icon={<SaveOutlined />}
                            onClick={handleSaveData}
                        >
                            Save
                        </Button>


                    </Flex>
                }>
                <TabPane tab="In Progress Boxes" key="1">
                    <Card>
                        {/* Controls row */}
                        <Flex align="center" style={{ gap: "10px", flexWrap: "wrap", marginBottom: "10px" }}>
                            <SearchComponent
                                style={{ width: "400px" }}
                                placeHolder="Search Unique ID or Spec or Barcode"
                                onChange={(e) => getData({ query: e.target.value })}
                            />
                            <Button
                                style={{ backgroundColor: '#249245ff' }}
                                shape="round"
                                type="primary"
                                onClick={() => setSearchModal(true)}
                            >
                                Search By Range Filters
                            </Button>
                            <Button
                                style={{ backgroundColor: '#da7e22ff' }}
                                shape="round"
                                type="primary"
                                icon={<DownloadOutlined />}
                                onClick={handleDownloadExcel}
                            >
                                Download Template
                            </Button>
                            <Button
                                style={{ backgroundColor: '#7e0e0eff' }}
                                shape="round"
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={showModal}
                            >
                                Upload Excel
                            </Button>




                            {clearData && (
                                <Button
                                    className="btn-danger"
                                    shape="round"
                                    icon={<ReloadOutlined />}
                                    onClick={clearFilterData}
                                >
                                    Clear Filters
                                </Button>
                            )}
                        </Flex>


                        <Modal
                            open={searchModal}
                            onCancel={() => {
                                setSearchModal(false);
                                setBarocdestartvalue(null);
                                setBarocdeendvalue(null);
                                setUniqueIdStartValue(null);
                                setUniqueIdEndValue(null);
                            }}
                            onOk={handleFilterChange}
                            okText="Search"
                            title={
                                <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                                    <SearchOutlined style={{ marginRight: 6 }} />
                                    Search Range Filter
                                </span>
                            }
                            width={650}
                        >
                            {/* Barcode Section */}
                            <span style={{ fontWeight: "bold", fontSize: "16px" }}>Barcode FIlter</span>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <label style={{ marginBottom: "6px", fontWeight: "500", display: "block" }}>
                                        Start Value
                                    </label>
                                    <Select
                                        showSearch
                                        options={getAllBarocde}
                                        placeholder="Enter Barcode Start Value"
                                        value={barocdestartvalue}
                                        onChange={(value) => setBarocdestartvalue(value)}
                                        style={{ width: "100%" }}
                                    />
                                </Col>
                                <Col span={12}>
                                    <label style={{ marginBottom: "6px", fontWeight: "500", display: "block" }}>
                                        End Value
                                    </label>
                                    <Select
                                        showSearch
                                        options={getAllBarocde}
                                        placeholder="Enter Barcode End Value"
                                        value={barocdeendvalue}
                                        onChange={(value) => setBarocdeendvalue(value)}
                                        style={{ width: "100%" }}
                                    />
                                </Col>
                            </Row>
                            {/* Unique ID Section */}
                            <div style={{ fontWeight: "bold", fontSize: "16px", marginTop: '20px' }}>Unique ID FIlter</div>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <label style={{ marginBottom: "6px", fontWeight: "500", display: "block" }}>
                                        Start Value
                                    </label>
                                    <Select
                                        showSearch
                                        options={getAllUniqueID}
                                        placeholder="Enter Unique ID Start Value"
                                        value={uniqueIdStartValue}
                                        onChange={(value) => setUniqueIdStartValue(value)}
                                        style={{ width: "100%" }}
                                    />
                                </Col>
                                <Col span={12}>
                                    <label style={{ marginBottom: "6px", fontWeight: "500", display: "block" }}>
                                        End Value
                                    </label>
                                    <Select
                                        showSearch
                                        options={getAllUniqueID}
                                        placeholder="Enter Unique ID End Value"
                                        value={uniqueIdEndValue}
                                        onChange={(value) => setUniqueIdEndValue(value)}
                                        style={{ width: "100%" }}
                                    />
                                </Col>
                            </Row>
                        </Modal>
                        {/* Table or other content below */}
                    </Card>


                    {weareHouseByIdData?.data?.length > 0 ? (
                        <>
                            <Form form={form} component={false}>
                                <TableComponent
                                    rowSelection={rowSelection}
                                    dataSource={activetab == '1' ? preprocessingQueueData : completedPreprocessingQueueData}
                                    columns={columns}
                                    onChangeDispatch={(payload) => {
                                        getData(payload);
                                        handleSaveData(payload, "pagination");
                                    }}
                                />

                            </Form>
                        </>) :
                        (<>
                            <TableComponent
                                rowSelection={rowSelection}

                                columns={columns}
                            />
                        </>
                        )}
                </TabPane>
                <TabPane tab="Barcode Printed Boxes" key="2">
                    <Space size={"middle"} className="my-3">

                        <SearchComponent
                            placeHolder="Search Unique ID or Spec or Scantek Barcode"
                            style={{ width: "500px" }}
                            onChange={e => {
                                const payloadData = {
                                    query: e.target.value,
                                };
                                getData(payloadData);
                            }} />


                    </Space>

                    {
                        completedWeareHouseByIdData?.data?.length > 0 ? (
                            <>
                                <Form form={form} component={false}>
                                    <TableComponent
                                        rowSelection={rowSelection}
                                        dataSource={activetab == '1' ? preprocessingQueueData : completedPreprocessingQueueData}
                                        columns={columns}
                                        onChangeDispatch={(payload) => {
                                            getData(payload);
                                            handleSaveData(payload, "pagination");
                                        }}
                                    />

                                </Form>
                            </>
                        ) : (
                            <>
                                <TableComponent
                                    rowSelection={rowSelection}

                                    columns={columns}
                                />
                            </>
                        )
                    }
                </TabPane>
            </Tabs>

            <Modal title="Upload Excel File" open={isModalOpen} onOk={handleUpload} onCancel={handleCancel} okText="Upload">
                <Upload
                    beforeUpload={(file) => {
                        setFileList([file]);
                        return false;
                    }}
                    fileList={fileList}
                    accept=".xlsx, .xls"
                >
                    <Button icon={<UploadOutlined />}>Select Excel File</Button>
                </Upload>
            </Modal>
            {weareHouseLoading ? <Loader /> : <>
                <Modal
                    title="Upload in Progress"
                    open={uploadModalVisible}
                    footer={[
                        <Button key="logs" type="primary" className='primary-btn' onClick={() => navigate("/upload-log")}>
                            Go to Upload Logs
                        </Button>,
                    ]}
                    onCancel={() => setUploadModalVisible(false)}
                >
                    <p>Data upload is in progress. Please check upload logs.</p>
                </Modal>
            </>}
            <Modal
                title={
                    <div style={{ textAlign: "center" }}>
                        <Title level={4} style={{ marginBottom: 0 }}>
                            Process Box - {selectedRecord?.box_unique_id || "N/A"}
                        </Title>
                        <Text type="secondary">Review and update details before saving</Text>
                    </div>
                }
                open={isProcessModalOpen}
                onCancel={() => {
                    setIsProcessModalOpen(false)
                    form.resetFields()
                }}
                onOk={() => form.submit()} // use Form submit for validation
                okText="Save Changes"
                cancelText="Cancel"
                width={1000}
                style={{ top: 30 }}
                styles={{ body: { backgroundColor: "#fafafa", borderRadius: "8px", padding: "24px" } }}

            >
                {selectedRecord && (
                    <Form
                        form={form}
                        layout="vertical"
                        initialValues={{
                            box_unique_id: selectedRecord.box_unique_id,
                            customer_name: selectedRecord.customer_name,
                            spec: selectedRecord.spec,
                            from: selectedRecord.from,
                            to: selectedRecord.to,
                            box: selectedRecord.box,
                            alt_box: selectedRecord.alt_box,
                            barcode: selectedRecord.barcode,
                            printed_name: selectedRecord.printed_name,
                            date_in: selectedRecord.date_in
                                ? dayjs(selectedRecord.date_in, 'MM/DD/YYYY')
                                : null,
                            description: selectedRecord.description,
                            series_box: selectedRecord.series_box,
                            loc: selectedRecord.loc,
                            building: selectedRecord.building,
                            aisle: selectedRecord.aisle,
                            level: selectedRecord.level,
                            shelf: selectedRecord.shelf,
                        }}
                        onFinish={(values) => {
                            // Format date before passing to handleSaveData
                            const formattedValues = {
                                ...values,
                                date_in: values.date_in ? dayjs(values.date_in).format('MM/DD/YYYY') : null
                            };
                            handleSaveData(formattedValues);
                        }}
                        style={{
                            background: "#fff",
                            padding: "20px",
                            borderRadius: "8px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                            maxHeight: "70vh",
                            overflowY: "auto",
                        }}
                    >
                        {/* Box Info */}
                        {/* <Divider orientation="left" plain>
                                        Box Information
                                    </Divider> */}
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item label="Box Unique ID" name="box_unique_id">
                                    <Input disabled />
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item
                                    label="Spec ID"
                                    name="spec"
                                // rules={[{ required: true, message: "Spec is required" }]}
                                >

                                    <Input
                                        value={selectedRecord.spec} disabled
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        {/* Spec and Transfer */}
                        {/* <Divider orientation="left" plain>
                                        Specification & Transfer
                                    </Divider> */}


                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="From "
                                    name="from"
                                    required
                                    dependencies={["spec"]}
                                    rules={[
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (!getFieldValue("spec") || value) return Promise.resolve();
                                                return Promise.reject(new Error("From  is required when Spec is selected"));
                                            },
                                        }),
                                    ]}
                                >
                                    <Input placeholder="Enter From " />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="To "
                                    name="to"
                                    required
                                    dependencies={["spec"]}
                                    rules={[
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (!getFieldValue("spec") || value) return Promise.resolve();
                                                return Promise.reject(new Error("To  is required when Spec is selected"));
                                            },
                                        }),
                                    ]}
                                >
                                    <Input placeholder="Enter To " />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="Description"
                                    name="description"
                                    required
                                    dependencies={["spec"]}
                                    rules={[
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (!getFieldValue("spec") || value) return Promise.resolve();
                                                return Promise.reject(new Error("Description is required when Spec is selected"));
                                            },
                                        }),
                                    ]}
                                >
                                    <Input.TextArea rows={2} placeholder="Enter Description" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Box Pickup Date"
                                    name="date_in"
                                    // required
                                    dependencies={["spec"]}
                                // rules={[
                                //     ({ getFieldValue }) => ({
                                //         validator(_, value) {
                                //             if (!getFieldValue("spec") || value) return Promise.resolve();
                                //             return Promise.reject(new Error("Box Pickup Date is required when Spec is selected"));
                                //         },
                                //     }),
                                // ]}
                                >
                                    <DatePicker format="MM/DD/YYYY" style={{ width: "100%" }} />
                                </Form.Item>
                            </Col>
                        </Row>
                        {/* Box & Barcode Info */}
                        {/* <Divider orientation="left" plain>
                                        Box & Barcode
                                    </Divider> */}
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item label="Box" name="box">
                                    <Input disabled={true} placeholder="Enter Box ID" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Alt Box" name="alt_box">
                                    <Input disabled={true} placeholder="Enter Alternate Box" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item label="Scantek Barcode" name="barcode">
                                    <Input disabled={true} placeholder="Enter Scantek Barcode" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Label Printed Name / Date" name="printed_name">
                                    <Input placeholder='Enter Label  Printed Name' />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>


                            <Col span={12}>
                                <Form.Item label="Series Box" name="series_box">
                                    <Input placeholder="Enter Series Box" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Level" name="level">
                                    <Input placeholder="Enter Level" />
                                </Form.Item>
                            </Col>
                        </Row>

                        {/* Description & Pickup Date */}
                        {/* <Divider orientation="left" plain>
                                        Processing Details
                                    </Divider> */}


                        {/* Location Details */}
                        {/* <Divider orientation="left" plain>
                                        Location Details
                                    </Divider> */}
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item label="LOC" name="loc">
                                    <Input placeholder="Enter Location Code" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Building / Address" name="building">
                                    <Input placeholder="Enter Building or Address" />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item label="Aisle" name="aisle">
                                    <Input placeholder="Enter Aisle" />
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item label="Shelf" name="shelf">
                                    <Input placeholder="Enter Shelf" />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                )}
            </Modal>
            {weareHouseLoading ? <Loader /> : <>
                <Modal
                    title="Upload in Progress"
                    open={uploadModalVisible}
                    footer={[
                        <Button key="logs" type="primary" className='primary-btn' onClick={() => navigate("/upload-log", { state: { activeTab: "warehouse" } })}>
                            Go to Upload Logs
                        </Button>,
                    ]}
                    onCancel={() => setUploadModalVisible(false)}
                >
                    <p>Data upload is in progress. Please check upload logs.</p>
                </Modal>
            </>}
        </>
    );
};

export default WareHouse;